export enum PathsToMonitor {
  IntegrationStatus = 'integrations.state.status',
  QuickbooksConnected = 'data.connected',
  IntegrationUpdatedField = 'integrations.state.updated',
  Ignore = 'IGNORE', // used for when checking updated only
  MetaUpdatedField = 'meta.updated',
  CampaignRunState = 'data.state',
}
